import { Icon, IconProps } from '@chakra-ui/react'

export default function DoneCheckIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#2BBB6E'}
      {...props}
    >
      <path
        d="M26.6663 9.16797L11.9997 23.8346L5.33301 17.168"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
